 


/* @ngInject */ 
export default function SideBar($rootScope, $templateCache, NavigationService, LocalStorageService) {
	var templateString = $templateCache.get('templates/flyout-menu/side-bar.html');
	return {
		restrict: 'E',
		link: SideBarLink,
		template: templateString
	};
	function SideBarLink(scope, element, attrs) {
		var $menus = $(element);
		var lin;
		var $subMenu;

		$('ul>li', $menus).click(function(evt) {
			var $item = $(this);
			var shouldCollapseOthers = !$item.hasClass('.sub-menus');
			evt.preventDefault();
			$('ul.sub-menu-list', $menus).each(function(i, sm) {
				var $sm = $(sm);
				if ($sm.css('display') === 'block') {
					$(sm).animate({ height: 'hide' }, 180, 'swing');
				}
			});

			var $anchor = $('a', $item);
			if ($anchor && $anchor.length > 0) {
				var route = $anchor.attr('ui-sref');

				if (route && route.length > 0) {
					LocalStorageService.clearSavedDates();
					$rootScope.$broadcast('navigate-changed', route);
				}
			}

			if (!$item.hasClass('sub-menus')) {
				scope.$parent.$eval(function() {
					$('#sideBarContainer burger-menu').trigger('click');
				});
				NavigationService.gotoTop();
			}

			// add logic to check if item has children, if it does don't run the above function
			// only apply to last child.
		});
		//});

		$('.sub-menus', $menus).each(function(i, el) {
			var $el = $(el);
			$el.click(function(e) {
				window.getSelection().removeAllRanges();
				var $target = $(e.target);
				var $subMenu = $target.closest('li.sub-menus');
				var $menuItems = $('ul.sub-menu-list', $subMenu);

				var isShowing = $menuItems.css('display') === 'block';
				e.preventDefault();

				if (!isShowing) {
					$menuItems.animate({ height: 'show' }, 250, 'swing');
				} else {
					$menuItems.animate({ height: 'hide' }, 180, 'swing');
				}

				NavigationService.gotoTop();
			});
		});
	}
}
